import React from 'react';
import styled from 'styled-components';
import breakpoints from '@rsc/ui-components/breakpoints';
import HorizontalDivider from '@components/HorizontalDivider';
import { useSportdogInternationalContext } from '@util/static-translations';

const Container = styled.div`
  padding: 0 2%;
  @media screen and (min-width: ${breakpoints.md}) {
    padding: 0 3%;
  }
  @media screen and (min-width: ${breakpoints.xl}) {
    padding: 0;
  }
`;

const GearTextImage = styled.img`
  margin: 0;
  object-fit: contain;
  width: 100%;
`;

function GearTagLine() {
  const { tt } = useSportdogInternationalContext({});

  return (
    <Container>
      <HorizontalDivider />
      <GearTextImage
        src="/images/gearthewayyouddesignit.png"
        alt={tt(s => s.gearTagLineComponent.gearTagAlt)}
      />
      <HorizontalDivider />
    </Container>
  );
}

export default GearTagLine;
